import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { formatDate2 } from "../../components/utils";
import logo from "../../assets/images/logo.png";
import FormatDate from "../Report/FormatDate";

pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts.vfs;

const compressImage = async (imageFile, maxWidth, maxHeight, quality) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(imageFile);

        img.onload = () => {
            const canvas = document.createElement("canvas");
            let width = img.width;
            let height = img.height;

            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, width, height);

            canvas.toBlob(
                (blob) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                },
                "image/jpeg",
                quality
            );
        };

        img.onerror = (error) => reject(error);
    });
};

const getBase64FromUrl = async (url) => {
    try {
        const response = await fetch(url);
        const blob = await response.blob();

        if (!blob.type.startsWith("image/")) {
            throw new Error("Invalid image format");
        }

        const compressedBase64 = await compressImage(blob, 300, 300, 0.7);
        return compressedBase64;
    } catch (error) {
        console.error("Error converting image to base64:", error);
        return null;
    }
};

const getColorTitle = (color) => {
    if (color === "#ff0000") {
        return "Trễ tiến độ";
    }
    if (color === "#ff5050") {
        return "Đúng ngày giao";
    }
    if (color === "#ffff00") {
        return "Gần giao dưới 3 ngày";
    }
    if (color === "#ffd966") {
        return "Gần giao dưới 1 tuần";
    }
    return "";
};
const getBase64Image = (img) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(img);
    });
};
const fetchImageAsBase64 = async (imagePath) => {
    const response = await fetch(imagePath);
    const blob = await response.blob();
    const base64Image = await getBase64Image(blob);
    return base64Image;
};

export const generatePdf = async (
    dataDVi,
    buildingName,
    categoryName,
    factoryCode,
    intendFinishDate,
    color
) => {
    const imagePath = logo;

    const logoBase64 = await fetchImageAsBase64(imagePath);
    if (!dataDVi || !dataDVi.data) {
        console.error("Data is null or undefined");
        return;
    }
    const reversedEvents = dataDVi.data.slice().reverse();
    const images = {};
    for (const event of reversedEvents) {
        for (const production of event.Productions) {
            if (production.images) {
                for (const image of production.images) {
                    try {
                        images[image] = await getBase64FromUrl(image);
                    } catch (error) {
                        console.error(`Failed to load image: ${image}`, error);
                    }
                }
            }
        }
    }

    // const groupImagesIntoRows = (images, maxPerRow) => {
    //     const rows = [];
    //     for (let i = 0; i < images.length; i += maxPerRow) {
    //         rows.push(images.slice(i, i + maxPerRow));
    //     }
    //     return rows;
    // };
    const getCurrentDate = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); // Tháng bắt đầu từ 0
        const yyyy = today.getFullYear();

        return `${dd}/${mm}/${yyyy}`;
    };
    const docDefinition = {
        pageSize: "A4",
        pageMargins: [40, 20, 0, 60],
        content: [
            {
                image: logoBase64,
                width: 40,
                absolutePosition: { x: 40, y: 20 },
            },
            {
                text: `DỰ ÁN: ${buildingName}`,
                style: "header",
                margin: [0, 0, 0, 10],
            },
            {
                text: `Báo cáo sản xuất`,
                style: "header",
                margin: [0, 0, 0, 10],
            },
            {
                text: `Update: ${getCurrentDate()}`,
                style: "dateText",
                margin: [0, 0, 10, 0],
            },
            {
                text: `Tên hạng mục: ${categoryName}`,
                style: "subheader",
                margin: [0, 0, 0, 10],
                alignment: "center",
            },
            {
                text: `Mã nhà máy: ${factoryCode}`,
                style: "subheader",
                margin: [0, 0, 0, 10],
                alignment: "center",
            },
            // {
            //     text: [
            //         `Kế hoạch hoàn thành: ${intendFinishDate}    `,
            //         {
            //             text: `${getColorTitle(color)}`,
            //             background: color,
            //             color: "black",
            //             padding: [10, 20, 10, 20],
            //         },
            //     ],
            //     style: "subheader",
            //     margin: [0, 10, 0, 10],
            // },
            ...reversedEvents.flatMap((event, index) => [
                ...event.Productions.map((production, prodIndex) => ({
                    columns: [
                        {
                            width: "80%", // Adjust the width of text column
                            stack: [
                                {
                                    text: `${event.name}`,
                                    style: "subheader",
                                    margin: [0, 20, 0, 5],
                                },
                                {
                                    text:
                                        event ===
                                        reversedEvents[
                                            reversedEvents.length - 1
                                        ]
                                            ? `Thời gian bắt đầu: ${formatDate2(
                                                  production.timeStart
                                              )}`
                                            : `Thời gian: ${
                                                  production.timeEnd
                                                      ? `${formatDate2(
                                                            production.timeStart
                                                        )} - ${formatDate2(
                                                            production.timeEnd
                                                        )}`
                                                      : `${formatDate2(
                                                            production.timeStart
                                                        )} - đang làm`
                                              }`,
                                    margin: [0, 0, 0, 5],
                                },
                                {
                                    text: `Số lượng: ${
                                        parseInt(event.totalEnd) !== 0
                                            ? event.totalEnd
                                            : event.totalStart
                                    }`,
                                    margin: [0, 0, 0, 5],
                                },
                                production.note
                                    ? {
                                          text: `Ghi chú: ${production.note}`,
                                          margin: [0, 0, 0, 5],
                                      }
                                    : null,
                            ].filter(Boolean),
                        },
                        // Cột ảnh
                        {
                            width: "20%",
                            stack: [
                                production.images &&
                                production.images.length > 0
                                    ? {
                                          image: images[
                                              production.images[
                                                  production.images.length - 1
                                              ]
                                          ], // Lấy ảnh cuối cùng
                                          width: 60,
                                          height: 60,
                                          margin: [10, 20, 0, 0],
                                      }
                                    : {
                                          text: "",
                                          margin: [0, 5, 0, 5],
                                      },
                            ],
                        },
                    ],
                    style: "borderText",
                })),
            ]),
        ],
        styles: {
            header: {
                fontSize: 18,
                bold: true,
                alignment: "center",
            },
            subheader: {
                fontSize: 14,
                bold: true,
            },
            borderText: {
                border: [true, true, true, true],
            },
            dateText: {
                fontSize: 10, // Kích thước font chữ nhỏ
                italics: true, // Chữ nghiêng
                alignment: "right",
                border: [true, true, true, true],
                padding: [100],
                borderWidth: 10, // Sử dụng số cho độ dày của đường viền
                borderColor: "black",
            },
        },
    };

    const pdfDocGenerator = pdfMake.createPdf(docDefinition);

    // Mở PDF trong tab mới
    pdfDocGenerator.open();

    // Tải xuống PDF
    pdfDocGenerator.download("BaoCaoDinhVi.pdf");
};
